var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"underconstruction-page"},[_c('p',[_vm._v(_vm._s(_vm.$t('global:underconstruction')))]),_c('img',{attrs:{"src":"/assets/images/themes/default/svg/underconstruction.svg"}})])}
var staticRenderFns = []

export { render, staticRenderFns }